module.exports = __webpack_public_path__ + "img/美食城.734c286c.png";